import { render } from "./WaitTime.vue?vue&type=template&id=ee1098cc&scoped=true"
import script from "./WaitTime.vue?vue&type=script&lang=js"
export * from "./WaitTime.vue?vue&type=script&lang=js"

import "./WaitTime.vue?vue&type=style&index=0&id=ee1098cc&scoped=true&lang=css"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee1098cc"]])

export default __exports__